import PropTypes from 'prop-types';
import React from 'react';
import classnames from 'classnames';
// import Button from '../Button';
// import Form from '../Form';
// import TextInput from '../TextInput';
import './styles.scss';
import tribePNG from 'resources/common/tribe-acad-student.png';

const Footer = ({
  inverted,
  className,
  children,
  columnItemsOne,
  columnItemsTwo,
  columnItemsThree,
  socialNavItems,
  footerBottomNavItems,
  copyrightText,
  newsLetterText,
  ...other
}) => {
  const classNames = classnames({
    footer: true,
    className: true,
    'bg-white': false,
  });

  const footer = children ? (
    <div {...other} className={classNames} style={{ position: 'relative' }}>
      {children}
    </div>
  ) : (
    <div className={classNames} style={{ position: 'relative' }}>
      <div className="pt-md-4 pb-4 footer-container page-max-width">
        <div className="ooter-main">
          <div className="container">
            <div className="row">
              <div className="text-center" style={{ margin: 'auto', paddingBottom: '1rem' }}>
                <img className="logo" src={tribePNG} alt="Tribe AcademyLogo" />
              </div>
            </div>
            <div className="text-center" style={{ fontSize: '15px' }}>
              {/*<span className="footer-bottom-copyright col-sm-4 col-xs-12 col-md-6 col-lg-9">
                {copyrightText}
              </span>*/}
              <small className="ml-3">
                This site is protected by reCAPTCHA and the Google{' '}
                <a href="https://policies.google.com/privacy">Privacy Policy</a> and{' '}
                <a href="https://policies.google.com/terms">Terms of Service</a> apply.
              </small>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  return footer;
};

Footer.propTypes = {
  inverted: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.string,
  labelOne: PropTypes.string,
  linkTextOne: PropTypes.string,
  linkHrefOne: PropTypes.string,
  labelTwo: PropTypes.string,
  linkTextTwo: PropTypes.string,
  linkHrefTwo: PropTypes.string,
  buttonText: PropTypes.string,
};

Footer.defaultProps = {
  labelOne: 'Need Help?',
  linkTextOne: 'Contact Bluemix Sales',
  linkHrefOne: '#',
  labelTwo: 'Estimate Monthly Cost',
  linkTextTwo: 'Cost Calculator',
  linkHrefTwo: '#',
  buttonText: 'Create',
};

export default Footer;



// WEBPACK FOOTER //
// ./src/ui/common/rebranding/components/Footer/Footer.js